"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Image from "next/image";
import { motion, useReducedMotion } from "framer-motion";
import { FaChevronRight } from "react-icons/fa";
import GradientButton from "@/components/ui/GradientButton";
interface LaravelStreamlinedDevProps {
  title?: string;
  paragraphs?: string[];
  buttonText?: string;
  buttonHref?: string;
  imageSrc?: string;
  imageAlt?: string;
  className?: string;
  /**
   * "about-agency" mirrors the live /laravel-development section exactly.
   * Leave unset (default) and the component keeps its original styling, so
   * /hire-laravel-developer is unaffected.
   */
  variant?: "default" | "about-agency";
}
const defaultParagraphs = ["Looking to build high-performing web applications quickly? We've got you covered with our talented Laravel developers for hire.", "With extensive experience in Laravel projects, our developers have mastered the framework to deliver exceptional results.", "Our senior Laravel developers specialize in writing clean, efficient code, ensuring a seamless and user-friendly experience. When you hire expert Laravel developers from The Dezine, you unlock the full potential of Laravel for your business.", "Share your project requirements with us and hire dedicated Laravel developers to build and maintain top-notch web applications."];
export default function LaravelStreamlinedDev(t0) {
  const $ = _c(77);
  const {
    title: t1,
    paragraphs: t2,
    buttonText: t3,
    buttonHref: t4,
    imageSrc: t5,
    imageAlt: t6,
    className: t7,
    variant: t8
  } = t0;
  const title = t1 === undefined ? "Get Expert Laravel Developers for Your Project at Budget-Friendly Rates" : t1;
  const paragraphs = t2 === undefined ? defaultParagraphs : t2;
  const buttonText = t3 === undefined ? "Hire Top Talent Now!" : t3;
  const buttonHref = t4 === undefined ? "/contact" : t4;
  const imageSrc = t5 === undefined ? "/images/laravel/laravel-developers.png" : t5;
  const imageAlt = t6 === undefined ? "Laravel Web Development Services" : t6;
  const className = t7 === undefined ? "" : t7;
  const variant = t8 === undefined ? "default" : t8;
  const desktopAnimations = useDesktopAnimations();
  useReducedMotion();
  const isAboutAgency = variant === "about-agency";
  const t9 = `relative overflow-hidden bg-white font-sans transition-colors duration-300 dark:bg-[#0b0f19] ${isAboutAgency ? "py-16 sm:py-20 lg:px-12 lg:py-[100px]" : "py-16 sm:py-20 lg:py-24"} ${className}`;
  let t10;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(#e5e5e5_0.5px,transparent_0.8px)] bg-[size:6px_6px] opacity-100 dark:bg-[radial-gradient(#1e293b_0.5px,transparent_0.8px)]" aria-hidden="true" />;
    $[0] = t10;
  } else {
    t10 = $[0];
  }
  let t11;
  if ($[1] !== isAboutAgency) {
    t11 = !isAboutAgency && <div className="pointer-events-none absolute -right-6 top-1/2 h-32 w-32 -translate-y-1/2 rounded-full bg-pink-100/40 blur-2xl dark:bg-pink-950/20" aria-hidden="true" />;
    $[1] = isAboutAgency;
    $[2] = t11;
  } else {
    t11 = $[2];
  }
  const t12 = isAboutAgency ? "relative z-10 mx-auto w-full max-w-[1200px] px-5 sm:px-8 lg:px-[15px]" : "relative z-10 mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8";
  const t13 = isAboutAgency ? "flex flex-col items-center gap-10 lg:flex-row lg:items-center lg:gap-[30px]" : "grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-12";
  let t14;
  if ($[3] !== desktopAnimations) {
    t14 = desktopAnimations ? {
      opacity: 0,
      x: -40
    } : false;
    $[3] = desktopAnimations;
    $[4] = t14;
  } else {
    t14 = $[4];
  }
  let t15;
  if ($[5] !== desktopAnimations) {
    t15 = desktopAnimations ? {
      opacity: 1,
      x: 0
    } : undefined;
    $[5] = desktopAnimations;
    $[6] = t15;
  } else {
    t15 = $[6];
  }
  let t16;
  if ($[7] !== desktopAnimations) {
    t16 = desktopAnimations ? undefined : {
      opacity: 1,
      x: 0
    };
    $[7] = desktopAnimations;
    $[8] = t16;
  } else {
    t16 = $[8];
  }
  let t17;
  let t18;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      once: true,
      amount: 0.2
    };
    t18 = {
      duration: 0.8,
      ease: "easeOut"
    };
    $[9] = t17;
    $[10] = t18;
  } else {
    t17 = $[9];
    t18 = $[10];
  }
  const t19 = isAboutAgency ? "flex w-full justify-center lg:w-1/2" : "flex justify-center lg:col-span-6";
  let t20;
  if ($[11] !== desktopAnimations || $[12] !== isAboutAgency) {
    t20 = desktopAnimations ? isAboutAgency ? {
      y: [0, 10, 0]
    } : {
      y: [0, -12, 0]
    } : undefined;
    $[11] = desktopAnimations;
    $[12] = isAboutAgency;
    $[13] = t20;
  } else {
    t20 = $[13];
  }
  let t21;
  if ($[14] !== desktopAnimations || $[15] !== isAboutAgency) {
    t21 = desktopAnimations ? {
      duration: isAboutAgency ? 3 : 4.5,
      repeat: Infinity,
      ease: "easeInOut"
    } : undefined;
    $[14] = desktopAnimations;
    $[15] = isAboutAgency;
    $[16] = t21;
  } else {
    t21 = $[16];
  }
  const t22 = isAboutAgency ? "relative w-full max-w-[570px]" : "relative flex w-full max-w-[580px] scale-105 items-center justify-center sm:scale-110 lg:scale-115";
  const t23 = isAboutAgency ? "h-auto w-full rounded-lg object-contain" : "h-auto w-full object-contain drop-shadow-md transition-transform duration-300 hover:scale-[1.02]";
  let t24;
  if ($[17] !== imageAlt || $[18] !== imageSrc || $[19] !== t23) {
    t24 = <Image src={imageSrc} alt={imageAlt} width={570} height={441} className={t23} loading="lazy" onError={_temp} />;
    $[17] = imageAlt;
    $[18] = imageSrc;
    $[19] = t23;
    $[20] = t24;
  } else {
    t24 = $[20];
  }
  let t25;
  if ($[21] !== t20 || $[22] !== t21 || $[23] !== t22 || $[24] !== t24) {
    t25 = <motion.div animate={t20} transition={t21} className={t22}>{t24}</motion.div>;
    $[21] = t20;
    $[22] = t21;
    $[23] = t22;
    $[24] = t24;
    $[25] = t25;
  } else {
    t25 = $[25];
  }
  let t26;
  if ($[26] !== t14 || $[27] !== t15 || $[28] !== t16 || $[29] !== t19 || $[30] !== t25) {
    t26 = <motion.div initial={t14} whileInView={t15} animate={t16} viewport={t17} transition={t18} className={t19}>{t25}</motion.div>;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
    $[29] = t19;
    $[30] = t25;
    $[31] = t26;
  } else {
    t26 = $[31];
  }
  let t27;
  if ($[32] !== desktopAnimations) {
    t27 = desktopAnimations ? {
      opacity: 0,
      x: 40
    } : false;
    $[32] = desktopAnimations;
    $[33] = t27;
  } else {
    t27 = $[33];
  }
  let t28;
  if ($[34] !== desktopAnimations) {
    t28 = desktopAnimations ? {
      opacity: 1,
      x: 0
    } : undefined;
    $[34] = desktopAnimations;
    $[35] = t28;
  } else {
    t28 = $[35];
  }
  let t29;
  if ($[36] !== desktopAnimations) {
    t29 = desktopAnimations ? undefined : {
      opacity: 1,
      x: 0
    };
    $[36] = desktopAnimations;
    $[37] = t29;
  } else {
    t29 = $[37];
  }
  let t30;
  let t31;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = {
      once: true,
      amount: 0.2
    };
    t31 = {
      duration: 0.8,
      delay: 0.1,
      ease: "easeOut"
    };
    $[38] = t30;
    $[39] = t31;
  } else {
    t30 = $[38];
    t31 = $[39];
  }
  const t32 = isAboutAgency ? "flex w-full flex-col items-start text-left lg:w-1/2" : "flex flex-col items-center text-center lg:col-span-6 lg:items-start lg:text-left";
  const t33 = isAboutAgency ? "m-0 font-poppins text-[26px] font-semibold leading-[36px] text-[#050748] sm:text-[30px] sm:leading-[42px] lg:text-[34px] lg:leading-[46px] dark:text-white" : "mb-6 font-poppins text-[28px] font-bold leading-[1.22] tracking-tight text-[#0b1354] sm:text-[34px] lg:text-[40px] dark:text-white";
  let t34;
  if ($[40] !== t33 || $[41] !== title) {
    t34 = <h2 className={t33}>{title}</h2>;
    $[40] = t33;
    $[41] = title;
    $[42] = t34;
  } else {
    t34 = $[42];
  }
  const t35 = isAboutAgency ? "w-full space-y-[10px] pt-[10px] font-open-sans text-[15px] leading-[26px] text-[#6a6a8e] sm:text-[17px] sm:leading-[28px] lg:text-justify dark:text-gray-300" : "w-full space-y-4 text-left font-sans text-[15px] leading-[1.75] text-[#5e6282] sm:text-[16px] dark:text-gray-300";
  let t36;
  if ($[43] !== paragraphs) {
    t36 = paragraphs.map(_temp2);
    $[43] = paragraphs;
    $[44] = t36;
  } else {
    t36 = $[44];
  }
  let t37;
  if ($[45] !== t35 || $[46] !== t36) {
    t37 = <div className={t35}>{t36}</div>;
    $[45] = t35;
    $[46] = t36;
    $[47] = t37;
  } else {
    t37 = $[47];
  }
  const t38 = isAboutAgency ? "mt-6" : "mt-8 flex justify-center lg:justify-start";
  const t39 = isAboutAgency ? "!px-8 !text-base !font-normal" : "max-w-[calc(100vw-32px)] !px-5 !text-[14px] sm:max-w-none sm:!px-8 sm:!text-[16px]";
  let t40;
  if ($[48] !== buttonText) {
    t40 = <span>{buttonText}</span>;
    $[48] = buttonText;
    $[49] = t40;
  } else {
    t40 = $[49];
  }
  let t41;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <FaChevronRight className="ml-1 shrink-0 text-[11px] sm:text-[12px]" />;
    $[50] = t41;
  } else {
    t41 = $[50];
  }
  let t42;
  if ($[51] !== buttonHref || $[52] !== t39 || $[53] !== t40) {
    t42 = <GradientButton href={buttonHref} variant="pink-purple" className={t39}>{t40}{t41}</GradientButton>;
    $[51] = buttonHref;
    $[52] = t39;
    $[53] = t40;
    $[54] = t42;
  } else {
    t42 = $[54];
  }
  let t43;
  if ($[55] !== t38 || $[56] !== t42) {
    t43 = <div className={t38}>{t42}</div>;
    $[55] = t38;
    $[56] = t42;
    $[57] = t43;
  } else {
    t43 = $[57];
  }
  let t44;
  if ($[58] !== t27 || $[59] !== t28 || $[60] !== t29 || $[61] !== t32 || $[62] !== t34 || $[63] !== t37 || $[64] !== t43) {
    t44 = <motion.div initial={t27} whileInView={t28} animate={t29} viewport={t30} transition={t31} className={t32}>{t34}{t37}{t43}</motion.div>;
    $[58] = t27;
    $[59] = t28;
    $[60] = t29;
    $[61] = t32;
    $[62] = t34;
    $[63] = t37;
    $[64] = t43;
    $[65] = t44;
  } else {
    t44 = $[65];
  }
  let t45;
  if ($[66] !== t13 || $[67] !== t26 || $[68] !== t44) {
    t45 = <div className={t13}>{t26}{t44}</div>;
    $[66] = t13;
    $[67] = t26;
    $[68] = t44;
    $[69] = t45;
  } else {
    t45 = $[69];
  }
  let t46;
  if ($[70] !== t12 || $[71] !== t45) {
    t46 = <div className={t12}>{t45}</div>;
    $[70] = t12;
    $[71] = t45;
    $[72] = t46;
  } else {
    t46 = $[72];
  }
  let t47;
  if ($[73] !== t11 || $[74] !== t46 || $[75] !== t9) {
    t47 = <section className={t9}>{t10}{t11}{t46}</section>;
    $[73] = t11;
    $[74] = t46;
    $[75] = t9;
    $[76] = t47;
  } else {
    t47 = $[76];
  }
  return t47;
}
function _temp2(p, idx) {
  return <p key={idx} className="m-0">{p}</p>;
}
function _temp(e) {
  e.currentTarget.src = "/images/flutter/multiple-application.png";
}